import React, { useEffect, useRef } from "react";
import luckysheet from "luckysheet";

interface LuckysheetWrapperProps {
  data?: any[];
  onDataChange?: (data: any[]) => void;
}

const LuckysheetWrapper: React.FC<LuckysheetWrapperProps> = ({ 
  data = [], 
  onDataChange 
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      // Initialize Luckysheet with sample data
      const options = {
        container: containerRef.current.id,
        title: 'My Spreadsheet',
        lang: 'en',
        data: data.length > 0 ? data : [
          {
            name: 'Sheet1',
            color: '',
            index: 0,
            status: 1,
            order: 0,
            hide: 0,
            row: 1000,
            column: 26,
            defaultRowHeight: 25,
            defaultColWidth: 100,
            celldata: [
              { r: 0, c: 0, v: { v: 'Welcome to Luckysheet!' } },
              { r: 1, c: 0, v: { v: 'A1' } },
              { r: 1, c: 1, v: { v: 'B1' } },
              { r: 2, c: 0, v: { v: 'A2' } },
              { r: 2, c: 1, v: { v: 'B2' } },
              { r: 3, c: 0, v: { v: '=SUM(A1:B2)' } }
            ],
            config: {},
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            isPivotTable: false,
            pivotTable: {},
            filter_select: {},
            filter: null,
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            luckysheet_conditionformat_save: {},
            frozen: {},
            chart: [],
            zoomRatio: 1,
            image: [],
            showGridLines: 1,
            dataVerification: {}
          }
        ],
        plugins: ['chart'],
        hook: {
          cellEditBefore: function(range: any) {
            console.log('Cell edit before:', range);
          },
          cellEditAfter: function(range: any, oldValue: any, newValue: any) {
            console.log('Cell edit after:', range, oldValue, newValue);
            if (onDataChange) {
              const currentData = luckysheet.getAllSheets();
              onDataChange(currentData);
            }
          }
        }
      };

      luckysheet.create(options);
    }

    // Cleanup on unmount
    return () => {
      try {
        luckysheet.destroy();
      } catch (error) {
        console.log('Luckysheet already destroyed or not initialized');
      }
    };
  }, [data, onDataChange]);

  return (
    <div 
      id="luckysheet" 
      ref={containerRef} 
      style={{ 
        height: "600px", 
        width: "100%",
        border: "1px solid #ccc",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif"
      }} 
    />
  );
};

export default LuckysheetWrapper; 